import React, { useEffect, useRef, useState, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Clientele from "../AboutSection/Clientele";

const LazyHireExExperts = lazy(() =>
  import("../HireExExpertSection/HireExExperts")
);
const LazyTestimonial = lazy(() => import("../TestimonySection/Testimonial"));

const Experience = () => {
  const location = useLocation();
  const hireRef = useRef(null);
  const testimonialRef = useRef(null);
  const [showHire, setShowHire] = useState(false);
  const [showTestimonial, setShowTestimonial] = useState(false);

  useEffect(() => {
    const sectionId = location.pathname.substring(1);
    setTimeout(() => {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }, [location]);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const hireObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShowHire(true);
        hireObserver.disconnect();
      }
    }, observerOptions);

    const testimonialObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShowTestimonial(true);
        testimonialObserver.disconnect();
      }
    }, observerOptions);

    if (hireRef.current) hireObserver.observe(hireRef.current);
    if (testimonialRef.current)
      testimonialObserver.observe(testimonialRef.current);

    return () => {
      hireObserver.disconnect();
      testimonialObserver.disconnect();
    };
  }, []);

  return (
    <div id="experience" className="category-page">
      <Clientele id="trusted-by-leading-brands" />

      <div id="hire-ex-experts" ref={hireRef} style={{height: '81vh'}}>
        {showHire && (
          <Suspense fallback={<div>Loading Hire Section...</div>}>
            <LazyHireExExperts />
          </Suspense>
        )}
      </div>

      <div id="hear-from-our-clients" ref={testimonialRef} style={{height: '100vh'}}>
        {showTestimonial && (
          <Suspense fallback={<div>Loading Testimonials...</div>}>
            <LazyTestimonial />
          </Suspense>
        )}
      </div>
    </div>
  );
};

export default Experience;
